import '../css/index.css';
import { scrollTracker } from "./utilities/scrollTracker"
import { masthead } from "./blocks/masthead"
import { team } from "./blocks/team"
import { gsapAnimations } from "./blocks/gsapAnimations"
import { choicesJS } from "./utilities/choices"
import { alignFull } from "./utilities/alignFull"
import { wpColumns } from "./blocks/wp-columns"
import { initPeopleAjax, initPostsAjax, initPublicationsAjax } from "./utilities/ajax"
import { navigation } from "./utilities/navigation"
import { wpBlockSocialIcons } from "./blocks/wp-block-social-icons"
import { lottieAnimations } from "./blocks/lottie"
import { videoOverlay } from "./utilities/videoOverlay"
import { timeline } from "./blocks/timeline"
import { cards } from "./blocks/cards"
import { locationsMap } from "./blocks/locationsMap"
import { hero } from "./blocks/hero"
import { scrollObserver } from "./utilities/scrollObserver"
import { livingCells } from "./blocks/livingCells"
import { wpBlockGroup } from "./blocks/wp-block-group"

document.addEventListener("DOMContentLoaded", () => {
  scrollTracker();
  masthead();
  gsapAnimations();
  wpColumns();
  choicesJS();
  alignFull();
  initPeopleAjax();
  initPublicationsAjax();
  initPostsAjax();
  navigation();
  wpBlockSocialIcons();
  lottieAnimations();
  videoOverlay();
  timeline();
  team();
  cards();
  locationsMap();
  hero();
  scrollObserver();
  livingCells();
  wpBlockGroup();
});


